export { default } from './ForgotForm';



// WEBPACK FOOTER //
// ./src/components/auth/ForgotForm/index.js